import { Icon } from '@iconify/react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSnackbar } from '../Providers/SnackbarProvider';
const addressDataList = [
  'info@digitalbyte.io',
];
const serviceMenuList = [
  {
    title: 'Custom Software Development',
    href: '/service/software-dev',
  },
  {
    title: 'Web Development',
    href: '/service/web-dev',
  },
  {
    title: 'Mobile App Development',
    href: '/service/mobile-app',
  },
  {
    title: 'UI/UX Design',
    href: '/service/ui-design',
  },
  {
    title: 'Systems Integration Consulting',
    href: '/contact',
  },
];
const LinksMenuList = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'About',
    href: '/about',
  },
  {
    title: 'Services',
    href: '/service',
  },
  {
    title: 'Blog',
    href: '/blog',
  },
  {
    title: 'Contact',
    href: '/contact',
  },
];
const policyMenuList = [
  {
    title: 'Terms of Use',
    href: '/',
  },
  {
    title: 'Privacy Policy',
    href: '/',
  },
];
export default function Footer() {
  const [email, setEmail] = useState(null);
  const { openSnackbar } = useSnackbar()

  const addSubscription = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${import.meta.env.REACT_APP_API_URL}/outreach/subscription`, {email});
      console.log()
      if (res.status === 200) {
        openSnackbar(`${email} has been added to subscription list!`, 'success');
      } else {
        openSnackbar(`An error has occured adding your email.`, 'error');
      }
    } catch (e) {
      openSnackbar(`An error has occured: ${e}`, 'error');
    }
  }
  return (
    <footer
      className="cs_fooer cs_bg_filed"
      style={{ backgroundImage: 'url(https://res.cloudinary.com/dam8havko/image/upload/v1715231190/dje_3_ovjrcw.jpg)' }}
    >
      <div className="cs_fooer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <div className="cs_text_widget">
                  <img src='https://res.cloudinary.com/dam8havko/image/upload/v1713329483/Group_7_mqswod.svg' alt="Logo" />
                </div>
                <ul className="cs_menu_widget cs_mp0">
                  {addressDataList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Services</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {serviceMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Links</h2>
                <ul className="cs_menu_widget cs_mp0">
                  {LinksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Subscribe Newsletter </h2>
                <div className="cs_newsletter cs_style_1">
                  <div className="cs_newsletter_text">
                    We make sure to only send emails that are noteworthy and
                    pertinent to the recipient.
                  </div>
                  <form action="#" className="cs_newsletter_form">
                    <input
                      type="email"
                      className="cs_newsletter_input"
                      placeholder="Email address"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button onClick={(e) => addSubscription(e)} className="cs_btn cs_style_1">
                      Join
                      <span>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="cs_bottom_footer">
          <div className="cs_copyright">Copyright © 2024 Digitalbyte LLC</div>
          <div className="cs_bottom_footer_right">
            <ul className="cs_footer_links cs_mp0">
              {policyMenuList.map((item, index) => (
                <li key={index}>
                  <Link to={item.href}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
